import actionConfirm from '../../../../procedures/action-confirm.js';
import httpWrap from '../../../../procedures/http-wrap.js';
import action from '../../../abstract/action.js';
import api from '../api';

const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {},
  },
) => {
  await actionConfirm({
    $vs,
    title: 'Ustaw jako domyślną',
    text: 'Czy na pewno chcesz ustawić wybraną numeracje jako domyślną dla przypisanego typu faktury.',
    action: async () => await httpWrap({
      $vs,
      action: api.makeDefault,
      success: { text: 'Szablon ustawiony jako domyślny' },
      onSuccess: reloadList,
    })(item),
  });
};


export default action({
  label: 'Ustaw domyślny',
  icon: 'CoffeeIcon',
  main: () => false,
  handle,
  render: ({ item: { is_default, _is_global } }) => !is_default || _is_global,
});
